import * as React from "react";
import SimpleSelect, {SimpleSelectItem} from "./SimpleSelect";
import FormFieldProps from "../FormFieldProps";
import UseLabelStrategy from "components/LabelStrategy/LabelStrategy";

export interface Item {
    value: string;
    text: string;
    icon?: JSX.Element;
    style?: object;
}

export interface OtherSelectProps {
    fixedLabel?: boolean;
    items: Item[];
    hintText?: string;
    allowClear?: boolean;
    allowFilter?: boolean;
    autoFocus?: boolean;
    disabled?: boolean;
    label?: string | JSX.Element;
    error?: string;
    warning?: string;
    selectionRenderer?: (value: string, menuItem: any) => any;
    validate?(value: string): string;
    onValidate?(value: string): void;
}

export type SelectProps = OtherSelectProps & FormFieldProps<string>;

interface SelectState {
    error?: string;
    showExternalError: boolean;
}

class SelectInternal extends React.Component<SelectProps, SelectState> {
    constructor(props: SelectProps) {
        super(props);
        this.state = {
            error: undefined,
            showExternalError: true,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps: SelectProps) {
        if (nextProps.error !== this.props.error) {
            this.setState({showExternalError: true});
        }
    }

    private handleChange = (value: string) => {
        if (this.props.validate) {
            const result = this.props.validate(value);
            this.setState({error: result});
            if (this.props.onValidate) {
                this.props.onValidate(result);
            }
        }
        this.setState({showExternalError: false});
        this.props.onChange(value);
    };

    render() {
        const {value, label, items, disabled, error, warning, hintText} = this.props;
        const errorText = this.state.error || (this.state.showExternalError && error) || warning;
        const simpleItems: SimpleSelectItem[] = items.map(i => ({value: i.value, text: i.text}));

        return (
            <SimpleSelect
                label={label}
                value={value}
                onChange={this.handleChange}
                items={simpleItems}
                disabled={disabled}
                placeholder={hintText}
                error={errorText}
            />
        );
    }
}

const Select = UseLabelStrategy(SelectInternal, fieldName => `Select ${fieldName}`);
export default Select;
export {SelectInternal};
